import React, { Component } from "react";
import "./App.scss";
import Routers from "./routes";
import {
  BrowserRouter as Router,Route, Switch
} from "react-router-dom";
import history from "./history";
import MainLayout from "./mainLayout";
import Idle from "react-idle";
import Cookies from 'universal-cookie';
import { bindActionCreators } from "redux";
import { ActCreators } from "./redux/bindActionCretor";
import { connect } from "react-redux";
import ScreeningSignIn from './pages/moderator/ScreeningSignIn'
import ScreeningPage from './pages/moderator/ScreeningPage'
import Moderator from "./pages/moderator";
import PS_moderator from "./pages/PS_moderator";
import PageTakeoverPreview from "./pages/pageTakeover/PageTakeoverPreview";
import { globalLogout } from "./utils/auth";
const cookies = new Cookies();

let sub;
const mapStateToProps = state => ({
  getLoginUser: state.getLoginUser,
  getLoginRole: state.getLoginRole,
  profileName: state.profileName,
  getBackToAdminFlag: state.getBackToAdminFlag
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch);
};

class App extends Component {
  componentDidMount() {
    setInterval(function () {
      // const User = cookies.get('SessionLogout');
    const User = localStorage.getItem('loginToken');
      if (User) {
        let currDate = new Date();
        let Time = process.env.REACT_APP_IDLE_LOGOUT_TIME;
        currDate.setTime(currDate.getTime() + +JSON.parse(Time));
        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "SessionLogout" : "SessionLogout", User, {
          path: "/",
          expires: currDate,
          secure: true,
        });
      }
    }, 10000);
  }

  logout = () => {
    // const User = cookies.get('SessionLogout');
    const User = localStorage.getItem('loginToken');
    if (User) {
        // App.js used window.open for expire redirect, passing specific URL.
        // If we strictly follow globalLogout, we use history.push.
        // However, App.js might not have history prop in the class directly accessed?
        // It has `Routers history={history}` in render.
        // And it imports `history`.
        // Let's use history from import.
        globalLogout(history);
        window.location.reload();
        // If the original App.js forced a window.open, maybe we should respect that?
        // Original: window.open(process.env.REACT_APP_REDIRECT_URL_EXPIRE, "_self");
        // globalLogout does: history.push('/') or /ps-signin.
        // If REACT_APP_REDIRECT_URL_EXPIRE is just '/', then it's fine.
        // If it's something else, we might be changing behavior.
        // But user said "import same function". So I will use globalLogout.
        
        this.setState({
            logoutLink: ""
        });
    } 
  };
  render() {
    return (
      <>
     
      <Router>
        <Switch>
          <Route path="/moderator" component={Moderator} />
          <Route path="/ps-moderator" component={PS_moderator} />
          <Route path="/page-takeover-preview" component={PageTakeoverPreview} />
       
        <MainLayout>
          <Idle timeout={process.env.REACT_APP_IDLE_LOGOUT_TIME} render={({ idle }) => <h1>{(!window.location.pathname.includes('/waitlist-management') && idle) ? this.logout() : ""} {console.log((!window.location.pathname.includes('/waitlist-management') && idle),"idle")}</h1>} />
          <Routers history={history} />
        </MainLayout>
        </Switch>
      </Router>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
